<template>
  <!-- Container para toda la página: ******************************************************* -->
  <v-container fill-height fluid class="administrators">
    <!-- Layout para toda la página: *********************************************************** -->
    <v-layout align-center justify-center>
      <!-- Flex para la ventana: **************************************************************** -->
      <v-flex xs12 sm10 elevation-6>
        <div class="sub-window">
          <v-toolbar dense dark color="teal darken-3">
            <v-toolbar-title>Administradores&nbsp;&nbsp;</v-toolbar-title>
             <v-text-field :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
              ></v-text-field>
              <v-btn :disabled="bEdit" small icon @click="onSearch">
                  <v-icon>search</v-icon>
              </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn :disabled="bEdit" text class="text-none" @click="onNewUser">Nuevo Administrador</v-btn>
              <v-btn
                :disabled="(bEdit || userID === 0 )"
                text
                class="text-none"
                @click="onEditUser"
              >Editar Administrador</v-btn>
              <v-btn
                :disabled="(bEdit || userID === 0 )"
                text
                class="text-none"
                @click="onDeleteUser"
              >Borrar Administrador</v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <span>Cerrar</span>
              </v-tooltip>
            </v-toolbar-items>

            <!-- Menú lateral para dispositivos con ventanas chicas: -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="hidden-md-and-up">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list color="grey lighten-4">
                <v-list-item :disabled="bEdit" @click="onNewUser">
                  <v-list-item-title>
                    <v-icon color="teal darken-1">note_add</v-icon>&nbsp; Nuevo Administrador
                  </v-list-item-title>
                </v-list-item>
                <v-list-item :disabled="bEdit" @click="onEditUser">
                  <v-list-item-title>
                    <v-icon color="teal darken-1">edit</v-icon>&nbsp; Editar Administrador
                  </v-list-item-title>
                </v-list-item>
                <v-list-item :disabled="bEdit" @click="onDeleteUser">
                  <v-list-item-title>
                    <v-icon color="teal darken-1">delete</v-icon>&nbsp; Borrar Administrador
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item :disabled="bEdit" @click="onClose">
                  <v-list-item-title>
                    <v-icon color="teal darken-1">close</v-icon>&nbsp; Cerrar
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>

          <!-- Container para lista de administradores y administrador seleccionado: -->
          <v-container pa-2 grid-list-md>
            <!-- Renglón único para lista de administradores y card de administrador seleccionado: -->
            <v-layout row>
              <!-- Lista de administradores: *************************** -->
              <v-flex xs4 sm4>
                <v-card>
                  <v-toolbar dense color="teal darken-1" dark flat>
                    <v-toolbar-title class="my-list-title">Administradores Registrados</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>list</v-icon>
                  </v-toolbar>

                  <v-list
                    subheader
                    dense
                    style="height: 578px; max-height:100%"
                    class="overflow-y-auto"
                    :disabled="bEdit"
                    color="grey lighten-4"
                  >
                    <v-list-item-group v-model="selectedUserIndex" color="orange accent-4" mandatory>
                      <v-list-item
                        class="my-list-item"
                        v-for="(user, i) in administrators"
                        :key="i"
                        @click="selectUser(user.usuariosid)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-container pa-0 fluid>
                              <v-layout row wrap>
                                <v-flex
                                  md2
                                  xs6
                                >{{ user.apaterno + " " + user.amaterno + " " + user.nombre}}</v-flex>
                              </v-layout>
                            </v-container>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-flex>

              <!-- Termina Lista de administradores ********************************* -->

              <!-- Info de administrador seleccionado: *********************** -->
              <v-flex xs8 sm8>
                <v-card class="grey lighten-4">
                  <v-toolbar dense color="teal lighten-3" flat>
                    <v-toolbar-title class="my-list-title">{{ selectedUserName }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>account_circle</v-icon>
                  </v-toolbar>

                  <v-card-text>
                    <v-container fluid>
                      <v-layout row wrap justify-space-between>
                        <v-flex xs10 md4>
                          <v-text-field
                            prepend-icon="person"
                            name="name"
                            label="Nombre(s)"
                            type="text"
                            v-model="name"
                            :readonly="!bEdit"
                            ref="name_field"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs10 md4>
                          <v-text-field
                            name="lastName1"
                            label="Apellido Paterno"
                            type="text"
                            v-model="lastName1"
                            :readonly="!bEdit"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs10 md4>
                          <v-text-field
                            name="lastName2"
                            label="Apellido Materno"
                            type="text"
                            v-model="lastName2"
                            :readonly="!bEdit"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap justify-space-between>
                        <v-flex xs10 md6>
                          <v-text-field
                            prepend-icon="email"
                            name="email"
                            label="Correo Electrónico"
                            type="email"
                            v-model="email"
                            :rules="emailRules"
                            :readonly="!bEdit || !bNew"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs10 md6>
                          <v-text-field
                            prepend-icon="phone"
                            name="phone"
                            label="Teléfono"
                            type="text"
                            v-model="phone"
                            :readonly="!bEdit"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <!-- <v-layout wrap row>
                        <v-flex xs10 md8 d-flex>
                          <v-select
                            prepend-icon="domain"
                            :items="companies"
                            item-text="nombre"
                            item-value="empresaid"
                            v-model="companyID"
                            label="Empresa"
                            :readonly="!bEdit"
                            color="teal darken-3"
                            item-color="teal darken-3"
                            no-data-text="No hay empresas registradas"
                          ></v-select>
                        </v-flex>
                      </v-layout> -->

                      <v-layout v-if="bNew" row wrap justify-space-between>
                        <v-flex xs10 md6>
                          <v-text-field
                            prepend-icon="lock"
                            name="password"
                            label="Contraseña"
                            id="password1"
                            type="password"
                            required
                            v-model="password1"
                            @click:append="() => (e1 = !e1)"
                            :type="e1 ? 'password' : 'text'"
                            :rules="passwordRules"
                            :readonly="!bEdit"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs10 md6>
                          <v-text-field
                            name="password"
                            label="Verificar contraseña"
                            id="password2"
                            type="password"
                            required
                            v-model="password2"
                            :append-icon="e1 ? 'visibility_off' : 'visibility'"
                            @click:append="() => (e1 = !e1)"
                            :type="e1 ? 'password' : 'text'"
                            :rules="passwordRules"
                            :readonly="!bEdit"
                            color="teal darken-3"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="bEdit && !bNew" row wrap justify-space-between>
                        <v-flex xs8 md5>
                          <!-- Modal para cambio de Password: **************************************** -->
                          <v-dialog v-model="dlgChangePasswd" persistent max-width="40%">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="teal lighten-3 text-none"
                                small
                                v-on="on"
                              >Cambiar Contraseña</v-btn>
                            </template>
                            <v-card class="grey lighten-4">
                              <v-toolbar dense color="teal lighten-3" flat>
                                <v-toolbar-title
                                  class="my-list-title"
                                >Cambio de Contraseña - {{ selectedUserName }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon>vpn_key</v-icon>
                              </v-toolbar>
                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout row wrap justify-space-around>
                                    <v-flex xs12 md8>
                                      <v-text-field
                                        prepend-icon="lock"
                                        name="password"
                                        label="Contraseña nueva"
                                        id="new_password1"
                                        type="password"
                                        required
                                        v-model="newPassword1"
                                        :append-icon="e1 ? 'visibility_off' : 'visibility'"
                                        @click:append="() => (e1 = !e1)"
                                        :type="e1 ? 'password' : 'text'"
                                        :rules="passwordRules"
                                        color="teal darken-3"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap justify-space-around>
                                    <v-flex xs12 md8>
                                      <v-text-field
                                        prepend-icon="lock"
                                        name="password"
                                        label="Verificar contraseña"
                                        id="new_password2"
                                        type="password"
                                        required
                                        v-model="newPassword2"
                                        @click:append="() => (e1 = !e1)"
                                        :type="e1 ? 'password' : 'text'"
                                        :rules="passwordRules"
                                        color="teal darken-3"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="teal darken-3"
                                  class="text-none"
                                  text
                                  @click="changePassword"
                                >OK</v-btn>
                                <v-btn
                                  color="pink darken-1"
                                  class="text-none"
                                  text
                                  @click="cancelChangePassword"
                                >Cancelar</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <!-- Termina Modal para cambio de Password *************************** -->
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="bEdit" align-center justify-end row fill-height>
                        <v-flex xs12 sm8 class="text-xs-center text-end">
                          <v-btn
                            color="teal darken-3"
                            class="text-none"
                            text
                            @click="onSave"
                            :disabled="!bEdit"
                          >OK</v-btn>
                          <v-btn
                            color="pink darken-1"
                            class="text-none"
                            text
                            @click="onCancel"
                            :disabled="!bEdit"
                          >Cancelar</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!-- Termina info de administrador seleccionado *********************** -->              
            </v-layout>

            <!-- Modal para confirmar borrado de administrador: **************************************** -->
            <v-layout row justify-center>
              <v-dialog v-model="bDeletingUser" persistent max-width="35%">
                <v-card class="grey lighten-4">
                  <v-toolbar dense color="orange darken-2" dark flat>
                    <v-toolbar-title class="my-list-title">Borrar Administrador</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon>delete</v-icon>
                    </v-toolbar>
                    <v-card-title class="text-center">
                      <div style="margin: auto">
                        <v-icon large color="orange darken-2">warning</v-icon>
                      </div>
                      &nbsp; ¿Desea borrar al administrador {{ selectedUserName }}?
                      </v-card-title>
                      <v-card-text class="text-center">Esta acción no se puede deshacer.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        color="teal darken-3"
                        class="text-none"
                        text
                        @click="deleteUserConfirmed"
                        >OK</v-btn>
                        <v-btn
                        color="pink darken-1"
                        class="text-none"
                        text
                        @click="cancelDeleteUser"
                        >Cancelar</v-btn>
                        </v-card-actions>
                        </v-card>
                      </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de administrador *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                          <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                            <v-card class="grey lighten-4">
                              <v-toolbar dense color="teal" dark flat>
                                <v-toolbar-title class="my-list-title">Búsqueda de administradores</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon>search</v-icon>
                              </v-toolbar>
                              <v-card-text>
                                <v-container>
                                  <v-layout row>
                                    <v-flex xs12 class="d-flex justify-center">
                                      <v-icon large color="orange darken-2">warning</v-icon>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row>
                                    <v-flex xs12 class="d-flex justify-center">No hay administradores registrados con ese nombre.</v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="teal darken-3"
                                  class="text-none"
                                  text
                                  @click="bShowNotFoundAlert = false"
                                >OK</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para informar que los passwords no coinciden: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bPasswdNotEqual" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Error al establecer la contraseña</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>vpn_key</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">error</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center">Las contraseñas no coinciden.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bPasswdNotEqual = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que los passwords no coinciden *************************** -->

                        <!-- Modal para informar que no se puede borrar el usuario porque es el usuario logueado: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bAutoDelete" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Error al intentar borrar administrador</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">error</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center">No es posible borrar a este administrador porque es el usuario de esta sesión.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bAutoDelete = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no se puede borrar el usuario porque es el usuario logueado *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                          <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                            <v-card class="grey lighten-4">
                              <v-toolbar dense color="teal" dark flat>
                                <v-toolbar-title class="my-list-title">Información Incompleta</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon>error_outline</v-icon>
                                </v-toolbar>
                                <v-card-title class="text-center">
                                  <v-container>
                                    <v-layout row>
                                      <v-flex xs12 class="d-flex justify-center">
                                        <v-icon large color="orange darken-2" >error</v-icon>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                      <v-flex xs12 class="d-flex justify-center">{{ errorMessage }}</v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-title>
                                
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="teal darken-3" class="text-none" text @click="bInvalidData = false">OK</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-layout>
                           <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                           <!-- Modal para indicar que ya existe otro usuario registrado con el mismo correo: *********************************** -->
                      <v-layout row justify-center>
                        <v-dialog v-model="duplicatedUserError" persistent :width="errorModalWidth">
                          <v-card class="grey lighten-4">
                            <v-toolbar dense color="teal" dark flat>
                              <v-toolbar-title class="my-list-title">Usuario Duplicado</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-icon>error_outline</v-icon>
                            </v-toolbar>
                            <v-card-title class="text-center">
                              <v-container>
                                <v-layout row>
                                  <v-flex xs12 class="d-flex justify-center">
                                    <v-icon large color="orange darken-2" >error</v-icon>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex xs12 class="d-flex justify-center">Ya existe otro usuario registrado con el mismo correo electrónico.</v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-title>
                                
                             <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="teal darken-3" class="text-none" text @click="onDuplicatedUser">OK</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-layout>
                      <!-- Termina Modal para indicar que ya existe otro usuario registrado con el mismo correo *********************************** -->

                        

            <!-- Termina renglón único para lista de administradores y administrador seleccionado -->
          </v-container>
          <!-- Termina container para lista de administradores y administrador seleccionado -->
        </div>
      </v-flex>
      <!-- Fin Flex para la ventana **************************************************************** -->
    </v-layout>
    <!-- Fin Layout para toda la página *********************************************************** -->
    <v-overlay :value="waitCursor">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
  <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'administrators',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bAutoDelete: false, //Indica que el usuario se quiere borrar a sí mismo.
            dlgChangePasswd: false,
            bChangePasswd: false,
            bPasswdNotEqual: false,
            bInvalidData: false,
            errorMessage: '',

            e1: true,
            userID: 0,
            name: '',
            lastName1: '',
            lastName2: '',
            email: '',
            phone: '',
            password1: '',
            password2: '',
            newPassword1: '',
            newPassword2: '',
            //companyID: 0,
            companyID: 1, //Hardcodeada a TW
            userType: 1, //Usuario Administrador.
            emailRules: [
                v => !!v || 'Introduzca su correo electrónico',
                v =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido.'
            ],
            passwordRules: [
                v => !!v || 'Introduzca la contraseña',
                v =>
                    v.length >= 6 ||
                    'La contraseña debe tener al menos 6 caracteres.'
            ],
            selectedUserName: '',
            bDeletingUser: false,
            searchText: '',
            bShowNotFoundAlert: false //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
        };
    },
    created() {
        this.selectFirstUser();
        //console.log("Users: ", this.administrators);
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onNewUser() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedUserName = 'Nuevo Administrador';
            this.selectedUserIndex = -1;

            this.userID = 0;
            this.name = '';
            this.lastName1 = '';
            this.lastName2 = '';
            this.email = '';
            this.phone = '';
            //this.companyID = 0;
            this.companyID = 1; //Hardcodeada a TW
            this.password1 = '';
            this.password2 = '';
            this.newPassword1 = '';
            this.newPassword2 = '';
            this.e1 = true;

            this.$refs.name_field.focus();
        },
        onDeleteUser() {
            if (this.loggedUserID === this.userID)
            {
              this.bAutoDelete = true;
            }
            else
            {
              this.bDeletingUser = true;
            }
            
        },
        cancelDeleteUser() {
            this.bDeletingUser = false;
        },
        deleteUserConfirmed() {
            this.bDeletingUser = false;
            this.$store.dispatch('deleteAdministrator', this.userID);
            this.selectFirstUser();
        },
        onEditUser() {
            this.newPassword1 = '';
            this.newPassword2 = '';
            this.e1 = true;
            this.bEdit = true;
        },
        changePassword() {
            if (this.newPassword1 === this.newPassword2) {
                this.dlgChangePasswd = false;
                this.bChangePasswd = true;
            } else {
              this.bPasswdNotEqual = true;
            }
        },
        cancelChangePassword() {
            this.dlgChangePasswd = false;
            this.bChangePasswd = false;
            this.newPassword1 = '';
            this.newPassword2 = '';
            this.e1 = true;
        },
        onCancel() {
            if (this.bNew) {
                //Selecciona al primer administrador de la lista:
                this.selectFirstUser();
                this.bNew = false;
            } else {
                this.newPassword1 = '';
                this.newPassword2 = '';
                this.e1 = true;
                //Vuelve a obtener los datos originales del administrador seleccionado:
                this.selectUser(this.userID);
            }
            this.bEdit = false;
        },
        onSave() {
            var bDataOK = false;

            //Se validan los datos:
            if (this.name === "")
            {
              this.bInvalidData = true;
              this.errorMessage = "El nombre es obligatorio."
            }
            else
            if (this.lastName1 === "")
            {
              this.bInvalidData = true;
              this.errorMessage = "El apellido paterno es obligatorio."
            }
            else
            if (this.email === "")
            {
              this.bInvalidData = true;
              this.errorMessage = "El correo electrónico es obligatorio."
            }
            //else
            // if (this.phone === "")
            // {
            //   this.bInvalidData = true;
            //   this.errorMessage = "El teléfono es obligatorio";
            // }
            else
            if (this.companyID === 0)
            {
              this.bInvalidData = true;
              this.errorMessage = "Seleccione una empresa.";
            }
            else
            {
              bDataOK = true;
            }
            if (!this.bNew && bDataOK)  //Edición de administrador...
            {
                var i;

                var password = '';
                if (this.bChangePasswd) {
                  password = this.newPassword1;
                  this.bChangePasswd = false;
                }

                const userInfo = {
                  usuariosid: this.userID,
                  activo: 1,
                  nombre: this.name,
                  apaterno: this.lastName1,
                  amaterno: this.lastName2,
                  tipousuariosid: this.userType,
                  correo: this.email,
                  telefono: this.phone,
                  empresaid: this.companyID,
                  password: password 
                }

                //Edición del registro en la BD:
                this.$store.dispatch('editUser', userInfo);

                for (i = 0; i < this.administrators.length; i++) {
                    if (this.administrators[i].usuariosid === this.userID) {
                      this.administrators[i].activo = 1;
                      this.administrators[i].nombre = this.name;
                      this.administrators[i].apaterno = this.lastName1;
                      this.administrators[i].amaterno = this.lastName2;
                      this.administrators[i].tipousuariosid = this.userType;
                      this.administrators[i].correo = this.email;
                      this.administrators[i].telefono = this.phone;
                      this.administrators[i].empresaid = this.companyID;

                        // if (this.bChangePasswd) {
                        //     this.administrators[i].password = this.newPassword1;
                        // }
                        // this.bChangePasswd = false;

                      break;
                    }
                }
            }
            else
            if (this.bNew && bDataOK) //Registro de nuevo administrador...
            {
              //Se valida el password:
              bDataOK = false;
              if (this.password1 === "")
                {
                  this.bInvalidData = true;
                  this.errorMessage = "Teclee la contraseña.";
                }
                else
                if (this.password2 === "")
                {
                  this.bInvalidData = true;
                  this.errorMessage = "Verifique la contraseña.";
                }
                else
                if (this.password1 != this.password2)
                {
                  this.bInvalidData = true;
                  this.errorMessage = "Las contraseñas no coinciden.";
                }
                else
                {
                  bDataOK = true;
                }

                if (bDataOK)
                {
                  this.bNew = false;

                  const newUser = {
                      activo: 1,
                      apaterno: this.lastName1,
                      amaterno: this.lastName2,
                      nombre: this.name,
                      correo: this.email,
                      telefono: this.phone,
                      tipousuariosid: this.userType,
                      empresaid: this.companyID,
                      password: this.password1,
                  };

                  this.$store.dispatch('saveNewUser', newUser);
                }
            }//end registro de nuevo usuario.

            if (bDataOK)
            {
              this.selectedUserName = this.lastName1 + ' ' + this.lastName2 + ' ' + this.name;
              this.bEdit = false;
            }
        },
        selectFirstUser() {
            if (this.administrators.length > 0) {
                this.selectedUserIndex = 0;
                var userID = this.administrators[this.selectedUserIndex].usuariosid;
                this.selectUser(userID);
            } else {
                this.selectedUserIndex = -1;
                this.userID = 0;
            }
        },
        selectUser(userID) {
            var i;
            for (i = 0; i < this.administrators.length; i++) {
                if (this.administrators[i].usuariosid === userID) {
                    this.userID = userID;
                    this.name = this.administrators[i].nombre;
                    this.lastName1 = this.administrators[i].apaterno;
                    this.lastName2 = this.administrators[i].amaterno;
                    this.userType = this.administrators[i].tipousuariosid;
                    this.email = this.administrators[i].correo;
                    this.phone = this.administrators[i].telefono;
                    this.companyID = this.administrators[i].empresaid;

                    this.selectedUserName =
                        this.lastName1 + ' ' + this.lastName2 + ' ' + this.name;

                    break;
                }
            }
            //console.log("userID = ", this.userID);
        },
        onSearch() {
            if (this.searchText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.administrators.length; i++) {
                    var strLowerCaseText = this.administrators[i].apaterno.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                         this.selectedUserIndex = i;
                         this.selectUser(this.administrators[i].usuariosid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },
        onDuplicatedUser()
        {
          this.duplicatedUserError = false;
          this.selectedUserName = 'Nuevo Administrador';
          this.bEdit = true;
          this.bNew = true;
        }
    },
    
    computed: {
        ...mapGetters(['loggedUserID', 'administrators', 'companies', 'waitCursor']),
        selectedUserIndex: {
            get() {
                return this.$store.getters.selectedUserIndex;
            },
            set(selectedUserIndex) {
                this.$store.dispatch(
                    'updateSelectedUserIndex',
                    selectedUserIndex
                );
            }
        },
        
        duplicatedUserError: {
          get() {
            return this.$store.getters.duplicatedUserError;
          },
          set(duplicatedUserError) {
            this.$store.dispatch('setDuplicatedUserError', duplicatedUserError);
          }
        },
        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.administrators {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>